import { Attribute, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { getFormErrorMessage } from '@app/core/utils/form-error-message.util';

@Component({
  standalone: true,
  selector: 'ups-select',
  styleUrl: './form-select.component.scss',
  templateUrl: './form-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'form-group input-underline d-block position-relative'
  },
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormSelectComponent
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: FormSelectComponent
    }
  ],
  imports: [
    IonicModule
  ],
})
export class FormSelectComponent implements OnInit, ControlValueAccessor, Validator {

  @Input({ required: true }) public options!: { label: string, value: string }[];
  @Input() public label: string = '';
  @Input() public value: string = '';
  @Input() public placeholder!: string;
  @Input() public required: boolean = false;
  @Input() public disabled: boolean = false;
  public styleString = '';
  public errorMsg!: string;
  public isTouched: boolean = false;
  protected formControl!: AbstractControl;
  protected onChange: (_val: any) => void = (_val: any) => {};
  protected onTouched: () => void = () => {};

  constructor(
    @Attribute('width') protected width: string,
    protected readonly el: ElementRef,
    protected readonly ch: ChangeDetectorRef
  ) { }

  public ngOnInit(): void{
    this.styleString = `
      --width: ${ this.el.nativeElement.offsetWidth || this.width }px;
      --offset-y: 19px;
      --offset-x: -14px;
    `;
  }

  public registerOnChange(fn: any): void{
    this.onChange = fn;
  }
  
  public registerOnTouched(fn: any): void{
    this.onTouched = fn;
  } 
  
  public writeValue(val: any): void{
    this.value = val; 
    this.ch.markForCheck();
  }
  
  public setDisabledState?(d: boolean): void{ 
    this.disabled = d; 
    this.ch.markForCheck();
  }

  public validate(control: AbstractControl): ValidationErrors | null{  
    this.formControl = control;
    return null;
  }

  public change({ value }: any): void{
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }

    if (!this.disabled) {
      this.value = value;
      this.onChange(this.value);
      this.errorMsg = getFormErrorMessage(this.formControl.errors, this.label);
    }
  }
}
